const Airtable = require("airtable")

const _base = (token, basedId) => {
  return new Airtable({
    apiKey: token,
  }).base(basedId)
}

const writeRecord = (token, basedId, tableName, data) => {
  const base = _base(token, basedId)

  return new Promise((resolve, reject) => {
    base(tableName).create(
      [
        {
          fields: data,
        },
      ],
      function (err, records) {
        if (err) {
          reject({ error: err })
        } else {
          resolve({ records: records })
        }
      },
    )
  })
}

const readRecords = (
  token,
  basedId,
  tableName,
  sortingField,
  sortingDirection,
  criteria = {},
  view = `Grid view`,
) => {
  const base = _base(token, basedId)

  const defaultSelectCriteria = {
    view: view,
    sort: [{ field: sortingField, direction: sortingDirection }],
  }

  const selectCriteria = { ...defaultSelectCriteria, ...criteria }

  return new Promise((resolve, reject) => {
    let data = []
    base(tableName)
      .select(selectCriteria)
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.

          records.forEach(function (record) {
            if (record.fields) data.push(record.fields)
          })

          // To fetch the next page of records, call `fetchNextPage`.
          // If there are more records, `page` will get called again.
          // If there are no more records, `done` will get called.
          fetchNextPage()
        },
        function done(err) {
          if (err) {
            reject({ error: err })
          } else {
            resolve({ records: data })
          }
        },
      )
  })
}

module.exports.AirtableApi = {
  writeRecord,
  readRecords,
}
